export const CONTENT_PLACEHOLDER = '{{content}}'

const HTML_BODY_OPEN_REGEX = /^\s*(?:<!DOCTYPE[^>]*>\s*)?<html[^>]*>\s*(?:<head[^>]*>[\s\S]*?<\/head>\s*)?<body[^>]*>\s*/i
const HTML_BODY_CLOSE_REGEX = /\s*<\/body>\s*<\/html>\s*$/i
const DEFAULT_HTML_BODY_OPEN = '<html>\n  <body>\n'
const DEFAULT_HTML_BODY_CLOSE = '\n  </body>\n</html>'
const CONTENT_DIV_OPEN_REGEX = /<div[^>]*\bid\s*=\s*["']content["'][^>]*>\s*$/i
const CONTENT_DIV_CLOSE_REGEX = /^\s*<\/div>/i
const DEFAULT_CONTENT_DIV_OPEN = '<div id="content">'
const DEFAULT_CONTENT_DIV_CLOSE = '</div>'

export function parseTemplateWrapper(emailTemplate) {
  const template = emailTemplate || ''
  const openMatch = template.match(HTML_BODY_OPEN_REGEX)
  const closeMatch = template.match(HTML_BODY_CLOSE_REGEX)

  if (!openMatch || !closeMatch) {
    return { inner: template, open: '', close: '' }
  }

  return {
    inner: template.slice(openMatch[0].length, template.length - closeMatch[0].length),
    open: openMatch[0],
    close: closeMatch[0]
  }
}

export function parseContentDivWrapper(inner) {
  const placeholderIndex = inner.indexOf(CONTENT_PLACEHOLDER)
  if (placeholderIndex === -1) {
    return {
      header: inner,
      footer: '',
      contentDivOpen: '',
      contentDivClose: ''
    }
  }

  const beforePlaceholder = inner.slice(0, placeholderIndex)
  const afterPlaceholder = inner.slice(placeholderIndex + CONTENT_PLACEHOLDER.length)
  const openMatch = beforePlaceholder.match(CONTENT_DIV_OPEN_REGEX)
  const closeMatch = afterPlaceholder.match(CONTENT_DIV_CLOSE_REGEX)

  if (!openMatch || !closeMatch) {
    return {
      header: beforePlaceholder,
      footer: afterPlaceholder,
      contentDivOpen: '',
      contentDivClose: ''
    }
  }

  return {
    header: beforePlaceholder.slice(0, beforePlaceholder.length - openMatch[0].length),
    footer: afterPlaceholder.slice(closeMatch[0].length),
    contentDivOpen: openMatch[0],
    contentDivClose: closeMatch[0]
  }
}

export function parseEmailTemplate(emailTemplate) {
  const { inner, open, close } = parseTemplateWrapper(emailTemplate)
  const contentParts = parseContentDivWrapper(inner)

  return {
    templateWrapperOpen: open,
    templateWrapperClose: close,
    headerText: contentParts.header,
    footerText: contentParts.footer,
    contentDivOpen: contentParts.contentDivOpen,
    contentDivClose: contentParts.contentDivClose
  }
}

export function assembleEmailTemplate({
  templateWrapperOpen = '',
  templateWrapperClose = '',
  headerText = '',
  footerText = '',
  contentDivOpen = '',
  contentDivClose = ''
}) {
  const resolvedContentDivOpen = contentDivOpen || DEFAULT_CONTENT_DIV_OPEN
  const resolvedContentDivClose = contentDivClose || DEFAULT_CONTENT_DIV_CLOSE
  const inner = `${headerText}${resolvedContentDivOpen}${CONTENT_PLACEHOLDER}${resolvedContentDivClose}${footerText}`
  const open = templateWrapperOpen || DEFAULT_HTML_BODY_OPEN
  const close = templateWrapperClose || DEFAULT_HTML_BODY_CLOSE

  return `${open}${inner}${close}`
}
